import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Text,
  TextInput,
  Grid,
  createStyles,
  Badge,
  Drawer,
  Avatar,
  Accordion,
  Menu,
  Loader,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useSelector } from "react-redux";
// import { editStaff, addStaff } from "../../services/staff";
// import { DropDownArrowSvg } from "../../components/Svgs/DropDownArrowSvg";
// import { StaffIcon } from "../../components/Svgs/StaffIcon";
// import { ProfileIcon } from "../../components/Svgs/ProfileIcon";
// import { PositionIcon } from "../../components/Svgs/PositionIcon";
// import { MailIcon } from "../../components/Svgs/MailIcon";
// import { LuBuilding } from "react-icons/lu";
import { decrypt } from "../../utils";
import { IconChevronDown } from "@tabler/icons-react";
import DashboardDateComponent from "../../components/DashboardDateComponent";
 import moment from "moment";
// import moment from "moment-timezone";
import { useDisclosure } from "@mantine/hooks";
import {
  updateAttendenceStaff,
  getAllAttendenceOfSingleStaff,
  getAllAttendenceStaff,
} from "../../services/staff";
import TableLoader from "../../components/TableLoader";
const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  btn: {
    marginLeft: "auto",
    marginTop: 50,
  },
  mymodal: {
    // width: 818,
    padding: "0 auto",
    borderRadius: "1rem",

    "& section": {
      borderRadius: "1rem",
      padding: 0,
      background: "#f5f5f5",
      display: "flex",
      flexDirection: "column",
      gap: "1rem",
    },
    "& section .mantine-1q36a81": {
      height: "100%",
    },
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
    "& .mantine-19pz3dh": {
      paddingTop: ".5rem",
      paddingBottom: ".5rem",
      // position: "static",
      // marginBottom:'1rem'
    },
    // "& form": {
    // },
  },
  mwd: {
    // width: "100%",
    justifyContent: "space-between",
    display: "flex",
    "& .mantine-Grid-col": {},
    "& .col-mt": {
      marginTop: "1rem",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
    },
  },
  modalTopHeader: {
    display: "flex",
    justifyContent: "space-between",
  },
  userDetails: {
    display: "flex",
    // width:'100%'
    gap: "0.5rem",
    alignItems: "center",
  },
  timeBox: {
    "& .time": {
      lineHeight: "1.75rem",
      fontFamily: "Inter",
      fontSize: "1.75rem",
      fontWeight: 600,
    },
    "& .timeSubTitle": {
      fontSize: ".9rem",
      color: "#737373",
    },
  },
  acordionsContainer: {
    "& .mantine-em6nbc": {
      margin: "0 !important",
    },
    "& .mantine-em6nbc .mantine-1eihuod": {
      background: "#fff",
      padding: 0,
    },
  },
  headingBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginTop: "2rem",
    marginBottom: "1rem",

    "& .mantine-Text-root": {
      fontWeight: 600,
    },
    "& .mantine-UnstyledButton-root": {
      margin: 0,
    },
  },
  accordionItem: {
    background: "#fff",
    borderRadius: "1rem",
    "& .dis": {
      opacity: "1",
      transition: ".3s",
    },
    "&[data-active] .dis": {
      opacity: "0",
    },
  },
  fullw: {
    paddingBottom: "4px",
    "& .total-box": {
      width: "100%",
      padding: "2px 14px",
      borderRadius: "8px",
      height: "40px",
      border: "1px solid #FAFAFA",
      fontSize: "14px",
      background: "#F5F5F5",
      color: "#737373",
      alignContent: "center",
    },
  },
  statusBox: {},
}));

const CustomTextInput = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "2px 14px",
      borderRadius: "8px",
      height: "44px",
      border: "1px solid #E5E5E5",
      "& input": {
        backgroundColor: "transparent",
        border: "none",
        paddingInline: 0,
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput {...rest} />
    </div>
  );
};

const AttendanceModal = ({
  mode,
  opened,
  onclose,
  title,
  trackId,
  view,
  setView,
  selectedItem,
  currentPage,
  // setRefresh,
  // refresh,
  ...data
}) => {
  const { classes } = useStyles();
  const edit = mode === "edit" ? true : false;
  const [thisStaff, setThisStaff] = useState(null);
  const [loading, setLoading] = useState(false);
  const [essentialAccordion, setEssentialAccordion] = useState(undefined);
  // const { addAttendanceStaffLoading, attendanceStaff } = useSelector(
  //   (state) => state?.staff
  // );

  let [selectedRow, setSelectedRow] = useState([]);
  useEffect(() => {
    trackId
      ? setEssentialAccordion(trackId)
      : setEssentialAccordion(selectedRow?.[0]?._id || undefined);
  }, [trackId, selectedRow]);
  let [selectedRowLoading, setSelectedRowLoading] = useState(false);
  let [entryIndex, setEntryIndex] = useState(0);
  let [breakIndex, setBreakIndex] = useState(0);
  let [constantArray, setConstantArray] = useState([]);
  const [totalHoursWorked, setTotalHoursWorked] = useState([]);
  const [opened2, { close, open }] = useDisclosure(false);
  const [dateRange, setDateRange] = useState({
    type: null,
    date: [
      moment().subtract(1, "month").startOf("day").toDate(),
      moment().endOf("day").toDate(),
    ],
  });
  const [range, setRange] = useState([
    moment(dateRange?.date?.[0]),
    moment(dateRange?.date?.[1]),
  ]);
  const { profile } = useSelector((state) => state?.profile);

  const attendenceStaff = async () => {
    try {
      setSelectedRowLoading(true);
      let response = await getAllAttendenceOfSingleStaff(selectedItem, range);
      setSelectedRow(response?.staffs);
    } catch (e) {
    } finally {
      setSelectedRowLoading(false);
    }
  };

  const allattendanceStaff = async () => {
    await getAllAttendenceStaff(currentPage, range);
  };

  useEffect(() => {
    attendenceStaff();
  }, [opened, selectedItem, range]);

  const clearForm = async () => {
    // form?.reset();
    await allattendanceStaff();
    onclose();
    view && setView(false);
  };

  const handleApply = () => {
    setRange(() => {
      let f = moment(dateRange?.date?.[0]);
      let t = moment(dateRange?.date?.[1]);

      return [f, t];
    });
    close();
  };
  function getBreakTimes(inout) {
    const breakTimes = [];

    for (let i = 0; i < inout.length - 1; i++) {
      const currentEnd = new Date(inout[i].end);
      const nextStart = new Date(inout[i + 1].start);

      if (currentEnd < nextStart) {
        breakTimes.push({
          breakStart: moment(currentEnd).format("hh:mm:ss A"),
          breakEnd: moment(nextStart).format("hh:mm:ss A"),
          durationInSeconds: (nextStart - currentEnd) / 1000,
        });
      }
    }

    return breakTimes;
  }

  function convertSecondsToTime(seconds, sec = true) {
    if (seconds) {
      const duration = moment.duration(seconds, "seconds");
      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();
      const secs = duration.seconds();
      let timeStr = `${hours}:${minutes}`;
      if (sec) timeStr += `:${secs}`;
      return timeStr;
    } else {
      return 0;
    }
  }

  const form = useForm({
    initialValues: {
      timeEntries: [],
    },
  });

  // useEffect(() => {
  //   // let tempSelectedRow =
  //   //   attendanceStaff?.attendanceStaff?.filter(
  //   //     (i) => i?.staff?.id === selectedItem
  //   //   ) || [];
  //   // setSelectedRow(tempSelectedRow);
  // }, [attendanceStaff, selectedItem]);

// const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;




  useEffect(() => {
    if (selectedRow?.length) {
      const newTimeEntries = selectedRow.map((item) => ({
        id: item?._id ? item._id : "",
        startTime: item?.startTime
          ? moment(item.startTime).format("hh:mm:ss A")
          : "",
        endTime: item?.endTime ? moment(item.endTime).format("hh:mm:ss A") : "",
        //        startTime: item?.startTime
        //   ? moment.utc(item.startTime).local().format("h:mm A")
        //   : "",
        // endTime: item?.endTime
        //   ? moment.utc(item.endTime).local().format("h:mm A")
        //   : "",
//         startTime: item?.startTime && item?.facility
// ?.timeZone
//           ? moment.utc(item.startTime).tz(item.facility
// .timeZone).format("hh:mm:ss A")
//           : "",
//         endTime: item?.endTime && item?.facility
// ?.timeZone
//           ? moment.utc(item.endTime).tz(item.facility
// .timeZone).format("hh:mm:ss A")
//           : "",


//  startTime : item?.startTime
//   ? moment.parseZone(item.startTime).tz(userTimeZone).format("hh:mm:ss A")
//   : "",

//  endTime : item?.endTime
//   ? moment.parseZone(item.endTime).tz(userTimeZone).format("hh:mm:ss A")
//   : "",

        // startTime: item?.startTime
        //   ? moment.utc(item.startTime).format("hh:mm:ss A")
        //   : "",
        // endTime: item?.endTime
        //   ? moment.utc(item.endTime).format("hh:mm:ss A")
        //   : "",
        breaks: getBreakTimes(item?.inout || []),
        date: item?.date?.date ? item?.date?.date : "",
      }));

      form.setValues({ timeEntries: newTimeEntries });
      setConstantArray(newTimeEntries);
    }
    setTotalHoursWorked(() => {
      let totalHours = 0;
      selectedRow?.map(
        (i) =>
          (totalHours += i?.total_work_time ? Number(i?.total_work_time) : 0)
      );
      return convertSecondsToTime(totalHours);
    });
    setThisStaff(selectedRow?.[0]?.staff);
  }, [selectedRow]);

  // useEffect(() => {
  //   if (selectedRow?.length) {
  //     const newTimeEntries = selectedRow.map((item) => {
  //       const timeZone =
  //         item?.checkin_type === "facility"
  //           ? item?.facility?.timeZone
  //           : item?.staff?.timeZone;

  //       return {
  //         id: item?._id ? item._id : "",
  //         startTime: item?.startTime && timeZone
  //           ? moment.tz(item.startTime, timeZone).format("hh:mm:ss A")
  //           : "",
  //         endTime: item?.endTime && timeZone
  //           ? moment.tz(item.endTime, timeZone).format("hh:mm:ss A")
  //           : "",
  //         breaks: getBreakTimes(item?.inout || []),
  //         date: item?.date?.date ? item.date.date : "",
  //       };
  //     });

  //     form.setValues({ timeEntries: newTimeEntries });
  //     setConstantArray(newTimeEntries);
  //   }

  //   setTotalHoursWorked(() => {
  //     let totalHours = 0;
  //     selectedRow?.map((i) => {
  //       totalHours += i?.total_work_time ? Number(i.total_work_time) : 0;
  //     });
  //     return convertSecondsToTime(totalHours);
  //   });

  //   setThisStaff(selectedRow?.[0]?.staff);
  // }, [selectedRow]);

  const changeStatus = async (data) => {
    try {
      setLoading(data?._id);
      let payload = {
        id: data?._id,
        approvedStatus: data?.approvedStatus,
      };
      let result = await updateAttendenceStaff([payload]);
      // setRefresh(!refresh);
      await attendenceStaff();
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (edit) {
        const validation = form.validate();
        const hasManualErrors = Object.keys(form.errors).length > 0;

        if (!validation.hasErrors && !hasManualErrors) {
          const changed = values.timeEntries.filter((item, index) => {
            const originalItem = constantArray[index];

            const isStartTimeChanged =
              item.startTime !== originalItem.startTime;

            const isEndTimeChanged = item.endTime !== originalItem.endTime;

            const isBreaksChanged =
              item.breaks.length !== originalItem.breaks.length ||
              item.breaks.some(
                (b, i) =>
                  JSON.stringify(b) !== JSON.stringify(originalItem.breaks[i])
              );

            // return isStartTimeChanged || isEndTimeChanged || isBreaksChanged;
            if (isStartTimeChanged || isEndTimeChanged || isBreaksChanged) {
              return {
                id: originalItem?.id,
                ...item,
              };
            }
          });
          if (changed?.length) {
            let payload = [...changed];
            let result = await updateAttendenceStaff(payload);
            // setRefresh(!refresh);
            await attendenceStaff();
          }
        } else {
          for (const [key, value] of Object.entries(form.errors)) {
            form.setFieldError(key, value);
          }
        }
      }
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };
  const getDurationInSeconds = (startStr, endStr) => {
    const start = moment(startStr, "hh:mm:ss A");
    const end = moment(endStr, "hh:mm:ss A");
    return start.isValid() && end.isValid() && end.isAfter(start)
      ? end.diff(start, "seconds")
      : 0;
  };

  function handleDurationUpdate() {
    const breakItem =
      form.values.timeEntries?.[entryIndex].breaks?.[breakIndex];
    const nextItem =
      form.values.timeEntries?.[entryIndex].breaks?.[breakIndex + 1];
    const nextStart = moment(nextItem?.breakStart, "hh:mm:ss A");
    const previousItem =
      form.values.timeEntries?.[entryIndex].breaks?.[breakIndex - 1];
    const previousEnd = moment(previousItem?.breakEnd, "hh:mm:ss A");
    const start = moment(breakItem?.breakStart, "hh:mm:ss A");
    const end = moment(breakItem?.breakEnd, "hh:mm:ss A");

    if (start.isValid() && end.isValid()) {
      if (end.isBefore(start)) {
        form.setFieldError(
          `timeEntries.${entryIndex}.breaks.${breakIndex}.breakEnd`,
          "Break end must be after break start"
        );
      } else if (nextStart.isBefore(end)) {
        form.setFieldError(
          `timeEntries.${entryIndex}.breaks.${breakIndex}.breakEnd`,
          "Break End must before next break start"
        );
      } else {
        form.clearFieldError(
          `timeEntries.${entryIndex}.breaks.${breakIndex}.breakEnd`
        );
      }

      if (start.isBefore(previousEnd)) {
        form.setFieldError(
          `timeEntries.${entryIndex}.breaks.${breakIndex}.breakStart`,
          "Break Start must be after previous break end"
        );
      } else {
        form.clearFieldError(
          `timeEntries.${entryIndex}.breaks.${breakIndex}.breakStart`
        );
      }

      // if (nextStart.isBefore(end)) {
      //   form.setFieldError(
      //     `timeEntries.${entryIndex}.breaks.${breakIndex}.breakEnd`,
      //     'Break End must before next break start'
      //   );
      // } else {
      //   form.clearFieldError(`timeEntries.${entryIndex}.breaks.${breakIndex}.breakEnd`);
      // }
    }
  }

  function handleDurationUpdateClockIn() {
    const breakItem = form.values.timeEntries?.[entryIndex];
    const start = moment(breakItem?.startTime, "hh:mm:ss A");
    const lastBreakItem = breakItem?.breaks?.[breakItem?.breaks?.length - 1];
    const lastBreak = moment(lastBreakItem?.breakEnd, "hh:mm:ss A");
    const end = moment(breakItem?.endTime, "hh:mm:ss A");

    if (start.isValid() && end.isValid()) {
      if (end.isBefore(start)) {
        form.setFieldError(
          `timeEntries.${entryIndex}.endTime`,
          "clock-out must be after clock-in start"
        );
      } else {
        form.clearFieldError(`timeEntries.${entryIndex}.endTime`);
      }

      if (end.isBefore(lastBreak)) {
        form.setFieldError(
          `timeEntries.${entryIndex}.endTime`,
          "clock-out must be after last Break"
        );
      } else {
        form.clearFieldError(`timeEntries.${entryIndex}.endTime`);
      }
    }
  }

  useEffect(() => {
    if (form?.values?.timeEntries?.length) {
      handleDurationUpdate();
      handleDurationUpdateClockIn();
    }
  }, [form.values]);

  return (
    <Drawer
      centered
      size={"70%"}
      shadow="md"
      radius={15}
      zIndex={1000}
      opened={opened}
      onClose={clearForm}
      overlayProps={{ blur: 3 }}
      className={classes.mymodal}
      position="right"
      title={
        <Text ff={"Inter"} fz={22} fw={600}>
          {title}
        </Text>
      }
    >
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Box
          className={classes.modalContentBG}
          sx={{
            padding: "1rem",
            background: "#fff",
            borderRadius: "1rem",
          }}
        >
          <Box className={classes.modalTopHeader}>
            <Box className={classes.userDetails}>
              <Avatar
                size={60}
                radius={50}
                shape="circle"
                src={
                  decrypt(thisStaff?.photo)
                    ? decrypt(thisStaff?.photo)
                    : thisStaff?.photo
                    ? thisStaff?.photo
                    : "/assets/images/personal2.png"
                }
              />
              <Box className={classes.userInfo}>
                {thisStaff?.name && (
                  <Text variant="text" c="#737373" fw={400} fz={12}>
                    {"Staff Name"}
                  </Text>
                )}
                <Text variant="text" fz={16} fw={600} ff={"Inter"}>
                  {thisStaff?.name}
                </Text>
                <Text variant="text" c={"#737373"} fw={400} fz={12}>
                  {thisStaff
                    ? thisStaff?.id.substring(
                        thisStaff?.id?.length - 6,
                        thisStaff?.id?.length
                      )
                    : ""}
                </Text>
              </Box>
            </Box>
            <Box className={classes.timeBox}>
              <Text className="timeSubTitle">Total Hours Worked</Text>
              <Text className="time">{totalHoursWorked}</Text>
            </Box>
          </Box>
        </Box>
        <Box className={classes.headingBox}>
          <Text>Time Details</Text>
          <Box>
            <DashboardDateComponent
              dateRange={dateRange}
              setDateRange={setDateRange}
              handleApply={handleApply}
              open={open}
              opened={opened2}
              close={close}
            />
          </Box>
        </Box>
        {selectedRowLoading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <TableLoader />
          </div>
        ) : selectedRow?.length ? (
          selectedRow?.map((item, index) => {
            // const workDurationInSeconds = getDurationInSeconds(item?.startTime , item?.endTime);
            return (
              <Box
                key={`${index}-${item?.id}`}
                style={{
                  overflowY: "auto",
                  maxHeight: "100%",
                  marginTop: "1rem",
                }}
                className={classes.acordionsContainer}
              >
                <Accordion
                  value={essentialAccordion}
                  onChange={setEssentialAccordion}
                  mx={10}
                  variant="separated"
                  chevron={<IconChevronDown size={34} color="gray" />}
                  chevronPosition="right"
                  chevronSize={34}
                  styles={{
                    color: "#fff",
                    chevron: {
                      transition: "transform 200ms ease",
                      "&[data-active]": {
                        transform: "rotate(180deg)",
                      },
                    },
                  }}
                >
                  <Accordion.Item
                    key={String(item?._id || index)}
                    value={String(item?._id || index)}
                    className={classes.accordionItem}
                  >
                    <Accordion.Control>
                      <div
                        className={classes.mwd}
                        sx={{
                          paddingBottom: 0,
                        }}
                      >
                        <div className="mantine-Grid-col">
                          {/* {moment(item?.date?.date).format("MM/DD/YYYY") || "-"} */}
                          {item?.date?.date
                            ? moment
                                .tz(item.date.date, item.staff?.timeZone)
                                .format("MM/DD/YYYY")
                            : "-"}
                        </div>
                        <div className="mantine-Grid-col dis">
                          {item?.staff?.name || "-"}
                        </div>
                        <div className="mantine-Grid-col dis">
                          {item?.total_work_time
                            ? convertSecondsToTime(item?.total_work_time)
                            : "0"}{" "}
                          Hours Worked
                        </div>
                        <div className="mantine-Grid-col dis">
                          {item?.total_break_time
                            ? convertSecondsToTime(item?.total_break_time)
                            : "0"}{" "}
                          Mins Break
                        </div>
                        <div
                          className="mantine-Grid-col"
                          style={{
                            color:
                              item?.approvedStatus === "approved"
                                ? "#027A48"
                                : "#6941C6",
                            fontWeight: 700,
                            textTransform: "capitalize",
                          }}
                        >
                          <Menu disabled={item?.status === "clock-in"}>
                            <Menu.Target>
                              <Box
                                style={{
                                  backgroundColor:
                                    item?.approvedStatus === "approved"
                                      ? "#ECFDF3"
                                      : "#F4F3FF",
                                  padding: "5px 10px",
                                  borderRadius: "30px",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: "7px",
                                  fontWeight: "400",
                                  flexWrap: "wrap",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                }}
                              >
                                {loading === item?._id ? (
                                  <Loader
                                    color={
                                      item?.approvedStatus === "approved"
                                        ? "#12B76A"
                                        : "#7A5AF8"
                                    }
                                    size={"xs"}
                                  />
                                ) : (
                                  <Badge
                                    size={10}
                                    style={{
                                      backgroundColor:
                                        item?.approvedStatus === "approved"
                                          ? "#12B76A"
                                          : "#7A5AF8",
                                      padding: 0,
                                      boxSizing: "border-box",
                                      height: 10,
                                      width: "10px",
                                    }}
                                    // circle
                                  ></Badge>
                                )}
                                {item?.approvedStatus || "pending"}
                              </Box>
                            </Menu.Target>
                            {edit && (
                              <Menu.Dropdown>
                                <Menu.Item
                                  onClick={() =>
                                    changeStatus({
                                      ...item,
                                      approvedStatus:
                                        item?.approvedStatus === "approved"
                                          ? "pending"
                                          : "approved",
                                    })
                                  }
                                  style={{
                                    textTransform: "capitalize",
                                    padding: "5px 10px",
                                  }}
                                  disabled={
                                    item?.staff?.id === profile?.user?.admin
                                  }
                                >
                                  {item?.approvedStatus === "approved"
                                    ? "pending"
                                    : "approved"}
                                </Menu.Item>
                              </Menu.Dropdown>
                            )}
                          </Menu>
                        </div>
                      </div>
                    </Accordion.Control>

                    <Accordion.Panel>
                      <Grid
                        gutter={10}
                        cols={3}
                        className={classes.mwd}
                        sx={{
                          paddingBottom: 30,
                        }}
                      >
                        {decrypt(item?.client?.form1)?.services ? (
                          <Grid.Col span={12} className="col-mt">
                            <Box className={classes.fullw}>
                              <Text ff={"Inter"} fz={14} fw={500} color="#000">
                                Service
                              </Text>
                              <CustomTextInput
                                id="service"
                                size="sm"
                                withAsterisk
                                value={
                                  decrypt(item?.client?.form1)?.services?.find(
                                    (i) => i.servicenumber == item.service
                                  )?.servicetitle
                                }
                              />
                            </Box>
                          </Grid.Col>
                        ) : (
                          false
                        )}

                        <Grid.Col span={5} className="col-mt">
                          <Box className={classes.fullw}>
                            <Text ff={"Inter"} fz={14} fw={500} color="#000">
                              Clock-in
                            </Text>
                            <CustomTextInput
                              id="startTime"
                              size="sm"
                              withAsterisk
                              {...form.getInputProps(
                                `timeEntries.${index}.startTime`
                              )}
                              onChange={(e) => {
                                const value = e.target.value;
                                form.setFieldValue(
                                  `timeEntries.${index}.startTime`,
                                  value
                                );
                                setEntryIndex(index);
                              }}
                              disabled={!edit}
                            />
                          </Box>
                        </Grid.Col>
                        <Grid.Col span={5} className="col-mt">
                          <input
                            type="hidden"
                            id="id"
                            name="id"
                            {...form.getInputProps(`timeEntries.${index}.id`)}
                          />

                          <Box className={classes.fullw}>
                            <Text ff={"Inter"} fz={14} fw={500} color="#000">
                              Clock-out
                            </Text>
                            <CustomTextInput
                              id="endTime"
                              size="sm"
                              withAsterisk
                              disabled={!edit}
                              {...form.getInputProps(
                                `timeEntries.${index}.endTime`
                              )}
                              onChange={(e) => {
                                const value = e.target.value;
                                form.setFieldValue(
                                  `timeEntries.${index}.endTime`,
                                  value
                                );
                                setEntryIndex(index);
                              }}
                            />
                          </Box>
                        </Grid.Col>
                        <Grid.Col span={2} className="col-mt">
                          <Box className={classes.fullw}>
                            <Box className="total-box">
                              {`${convertSecondsToTime(
                                item?.total_work_time
                              )} ${
                                Number(item?.total_work_time) > 3600
                                  ? "Hours"
                                  : "Mins"
                              } Worked` || "-"}
                            </Box>
                          </Box>
                        </Grid.Col>
                        {form.values.timeEntries?.[index]?.breaks?.map(
                          (breakItem, breakIndex) => {
                            const durationInSeconds = getDurationInSeconds(
                              breakItem.breakStart,
                              breakItem.breakEnd
                            );
                            return (
                              <Grid.Col
                                span={12}
                                className="col-mt"
                                key={item?.id}
                              >
                                <Grid
                                  gutter={10}
                                  cols={3}
                                  className={classes.mwd}
                                >
                                  <Grid.Col
                                    span={5}
                                    className="col-mt"
                                    style={{ marginTop: 0 }}
                                  >
                                    <Box className={classes.fullw}>
                                      <Text
                                        ff={"Inter"}
                                        fz={14}
                                        fw={500}
                                        color="#000"
                                      >
                                        Break Start
                                      </Text>
                                      <CustomTextInput
                                        id="breakStart"
                                        size="sm"
                                        withAsterisk
                                        disabled={!edit}
                                        {...form.getInputProps(
                                          `timeEntries.${index}.breaks.${breakIndex}.breakStart`
                                        )}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          form.setFieldValue(
                                            `timeEntries.${index}.breaks.${breakIndex}.breakStart`,
                                            value
                                          );
                                          setEntryIndex(index);
                                          setBreakIndex(breakIndex);
                                        }}
                                      />
                                    </Box>
                                  </Grid.Col>
                                  <Grid.Col
                                    span={5}
                                    className="col-mt"
                                    style={{ marginTop: 0 }}
                                  >
                                    <Box className={classes.fullw}>
                                      <Text
                                        ff={"Inter"}
                                        fz={14}
                                        fw={500}
                                        color="#000"
                                      >
                                        Break End
                                      </Text>
                                      <CustomTextInput
                                        id="breakEnd"
                                        size="sm"
                                        withAsterisk
                                        disabled={!edit}
                                        {...form.getInputProps(
                                          `timeEntries.${index}.breaks.${breakIndex}.breakEnd`
                                        )}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          form.setFieldValue(
                                            `timeEntries.${index}.breaks.${breakIndex}.breakEnd`,
                                            value
                                          );
                                          setEntryIndex(index);
                                          setBreakIndex(breakIndex);
                                        }}
                                      />
                                    </Box>
                                  </Grid.Col>
                                  <Grid.Col
                                    span={2}
                                    className="col-mt"
                                    style={{ marginTop: 0 }}
                                  >
                                    <Box className={classes.fullw}>
                                      <Box className="total-box">
                                        {durationInSeconds
                                          ? `${convertSecondsToTime(
                                              durationInSeconds
                                            )} ${
                                              durationInSeconds > 3600
                                                ? "Hours"
                                                : "Mins"
                                            } Break`
                                          : "-"}
                                      </Box>
                                    </Box>
                                  </Grid.Col>
                                </Grid>
                              </Grid.Col>
                            );
                          }
                        )}
                      </Grid>
                    </Accordion.Panel>
                  </Accordion.Item>
                </Accordion>
              </Box>
            );
          })
        ) : (
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "auto",
            }}
          >
            <Text color="#737373">No work logs found</Text>
          </Box>
        )}
        {selectedRow?.length && edit ? (
          <Button type="submit" color="yellow" style={{ margin: "1rem 0" }}>
            Submit
          </Button>
        ) : (
          false
        )}
      </form>
    </Drawer>
  );
};

export default AttendanceModal;
